export default "__VITE_ASSET__baab7db2__"